import { ArrowRight, Info, Loader2 } from "lucide-react";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorButton,
  RazorCopyText,
  RazorDateTime,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
} from "../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import {
  disburtAllQueuedTransactions,
  disburtSingleQueuedTransactions,
  getQueuingTransaction,
} from "../../../redux/transaction";
import { useContext, useEffect, useState } from "react";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import ActionContext from "../../../context/ActionContext";
import NoContentPage from "../../../layout/dashboard/no-content/NoContentPage";
const headerList = [
  "Trx Reference",
  "Date",
  "Sender’s Name",
  "Recipient’s Name",
  "Amount",
  "Currency EXR Type",
  "Action",
];

export default function QueuingTransaction() {
  const dispatch = useDispatch();
  const actionCtx = useContext(ActionContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [swapId, setSwapId] = useState("");
  const { queuing_transactions, loading_queuing, loading_disburse } =
    useSelector((state: RootState) => state.transaction);

  useEffect(() => {
    dispatch(
      getQueuingTransaction({
        page: currentPage,
        per_page: actionCtx?.perPage?.label,
      }) as any,
    );
  }, [currentPage, actionCtx?.perPage]);

  const handleAllDisburst = async () => {
    setSwapId("");
    const data = await dispatch(disburtAllQueuedTransactions() as any);

    if (data?.payload?.data?.status) {
      dispatch(
        getQueuingTransaction({
          page: 1,
          per_page: actionCtx?.perPage?.label,
        }) as any,
      );
    }
  };

  const handleSingleDisburst = async (swapId: string) => {
    const data = await dispatch(disburtSingleQueuedTransactions(swapId) as any);

    if (data?.payload?.data?.status) {
      dispatch(
        getQueuingTransaction({
          page: 1,
          per_page: actionCtx?.perPage?.label,
        }) as any,
      );
      setSwapId("");
    }
  };

  return (
    <DashboardLayoutMain
      loading={loading_queuing && !queuing_transactions}
      title="Transactions"
    >
      <section className=" px-[20px] py-[20px]">
        <div className="space-y-[4px]">
          <p className="text-[16px] font-bold text-[#1e1e1e]">
            Pending Payouts
          </p>
          <p className="text-[14px] text-[#758089] font-medium">
            Manage and disburse pending transaction payments
          </p>
        </div>

        <div className="grid grid-cols-3 xl:grid-cols-4 gap-[12px] mt-[20px]">
          {queuing_transactions?.totals?.map((item: any, idx: any) => (
            <div className="bg-white border-[1px] border-[#E6E6E6] rounded-[8px] p-[14px]">
              <CurrencyText
                currency={item?.currency?.code || "ngn"}
                text={item?.currency?.code || "NGN"}
              />
              <p className="text-[24px] font-medium text-[#191C1F] mt-[12px] mb-[4px]">
                {RazorNumberFormat(item?.amount, {
                  symbol: item?.currency?.code,
                })}
              </p>
              <p className="inline-flex items-center gap-[4px] text-[#FFC043] text-[14px]">
                <Info className="size-[18px]" />
                <span className="">{item?.count} pending</span>
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-between mt-[20px]">
          <div>
            <p className="text-[16px] font-medium text-[#1e1e1e]">
              Transaction Queue
            </p>
            <p className="text-[14px] text-[#3B4046]">
              {queuing_transactions?.transactions?.meta?.total || 0}{" "}
              transactions waiting for disbursement
            </p>
          </div>

          <RazorButton
            color="black-light"
            label="Disburse all funds"
            className="btn btn-sm btn-title"
            size="small"
            disabled={
              loading_disburse ||
              queuing_transactions?.transactions?.data?.length < 1
            }
            onClick={handleAllDisburst}
            loading={loading_disburse && !swapId}
          />
        </div>

        <div className="table-section-box">
          {queuing_transactions?.transactions?.data?.length < 1 &&
          !loading_queuing ? (
            <NoContentPage
              title="No Queuing transactions"
              text="All payouts have been processed"
            />
          ) : (
            <RazorTable headerList={headerList} className="mt-[24px]">
              {queuing_transactions?.transactions?.data?.map(
                (chi: any, idx: any) => {
                  return (
                    <RazorTableRow
                      key={idx}
                      loading={loading_queuing}
                      one={
                        chi?.tx_reference ? (
                          <RazorCopyText
                            reference={chi?.tx_reference}
                            textToCopy={chi?.tx_reference}
                            outerCopy
                          />
                        ) : (
                          "-----"
                        )
                      }
                      two={<RazorDateTime date={chi?.payout_queued_at} />}
                      three={chi?.sender_name || "-----"}
                      four={chi?.recipient_name || "-----"}
                      five={
                        RazorNumberFormat(chi?.credit_amount, {
                          symbol: chi?.destination_currency?.code,
                        }) || "-----"
                      }
                      six={chi?.currency_exchange_type || "-----"}
                      seven={
                        <button
                          type="button"
                          className="bg-white inline-flex items-center border-[1px] border-primary text-primary rounded-lg px-[8px] py-[4px] text-[14px] font-medium"
                          disabled={loading_disburse}
                          onClick={() => {
                            setSwapId(chi?.id);
                            handleSingleDisburst(chi?.id);
                          }}
                        >
                          Disburse
                          {loading_disburse && swapId === chi?.id ? (
                            <Loader2 className="size-[18px] ml-[4px] animate-spin" />
                          ) : (
                            <ArrowRight className="size-[18px] ml-[4px]" />
                          )}
                        </button>
                      }
                    />
                  );
                },
              )}
            </RazorTable>
          )}
        </div>
        <PaginationFragment
          currentPage={
            queuing_transactions?.transactions?.meta?.current_page || 1
          }
          perPage={queuing_transactions?.transactions?.meta?.per_page}
          totalPage={queuing_transactions?.transactions?.meta?.total}
          onPageChange={(num) => {
            setCurrentPage(num);
          }}
          hidePagination={loading_queuing}
          showPerPage
        />
      </section>
    </DashboardLayoutMain>
  );
}
